import { createCrudPage } from './factories/crud-page.js';

// TODO: key, oauth_client_id, oauth_client_secret are credentials —
// consider masked/password field type when available.

export default createCrudPage({
  title: 'Order Card Providers',
  basePath: '/order-card-provider',
  rowKey: 'pid',
  columns: [
    { key: 'country_name', label: 'Country', sortable: true },
    { key: 'card_provider', label: 'Card Provider', sortable: true },
    { key: 'type', label: 'Environment', sortable: true,
      render: (v) => v == 1 ? 'Production' : v == 2 ? 'Sandbox' : String(v ?? '') },
    { key: 'pos_id', label: 'POS ID', sortable: true },
    { key: 'lang', label: 'Language', sortable: true },
  ],
  fields: [
    { key: 'country', label: 'Country', type: 'async-select',
      optionsUrl: '/countries/options', required: true },
    { key: 'card_provider', label: 'Card Provider', type: 'text', required: true },
    { key: 'type', label: 'Environment Type', type: 'radio',
      options: [
        { label: 'Production', value: '1' },
        { label: 'Sandbox', value: '2' },
      ],
      defaultValue: '2',
      codec: { parse: (v) => v != null ? String(v) : '', serialize: (v) => v } },
    { key: 'lang', label: 'Language', type: 'select',
      options: [
        { label: 'English', value: 'en' },
        { label: 'Polish', value: 'pl' },
        { label: 'German', value: 'de' },
        { label: 'Italian', value: 'it' },
      ],
      defaultValue: 'en' },
    { key: 'pos_id', label: 'POS ID', type: 'text' },
    { key: 'key', label: 'Key', type: 'text' },
    { key: 'oauth_client_id', label: 'OAuth Client ID', type: 'text' },
    { key: 'oauth_client_secret', label: 'OAuth Client Secret', type: 'text' },
  ],
  defaultSort: { field: 'country_name', dir: 'asc' },
});
